import type {Rooms} from 'src/types/scheduler/rooms';
import type {SchedulerRoomsActions} from 'src/action-creators/scheduler/rooms';

import {SET_ROOMS} from 'src/action-creators/scheduler/rooms';


export default (state: Rooms = [], action: SchedulerRoomsActions): Rooms => {
  switch (action.type) {
    case SET_ROOMS:
      return action.payload;
    default:
      return state;
  }
};
